<template>
  <card v-if="cardType==='CustomComponent'" :title="cardName">
    <div class="clear-float p-margin">
      <component
        v-if="component.isShow"
        :is="componentName(component.type)"
        v-for="component in displayComponentList"
        class='lf'
        :key="component.sort"
        v-bind="component"></component>
    </div>
    <!-- 证书异常时，底部“认证证书：查看”由状态文字代替 -->
    <div v-if="certificateStatusText" class="certificate-status">{{ certificateStatusText }}</div>
  </card>
  <div v-else-if="cardType==='OurStory'" class="clear-float">
    <component
      v-if="component.isShow"
      :is="componentName(component.type)"
      v-for="component in componentList"
      :key="component.sort"
      v-bind="component"></component>
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'
  import PText from '@views/general/customcomponent/components/PText.vue'
  import { getComponentNameByComponentTypeEnums } from '@/enums/ComponentTypeEnums'
  import { CertificateAbnormalStatusList, isCertificateAbnormal } from '@/enums/CertificateStatusEnums'
  import PImage from '@views/general/customcomponent/components/PImage.vue'
  import PFlow from '@views/general/customcomponent/components/PFlow.vue'
  import PVideo from '@views/general/customcomponent/components/PVideo.vue'
  import PAttachment from '@views/general/customcomponent/components/PAttachment.vue'
  import PCarousel from '@views/general/customcomponent/components/PCarousel.vue'

  export default {
    name: 'CustomComponent',
    components: { PCarousel, PAttachment, PVideo, PFlow, PImage, PText, card },
    props: {
      cardName: {
        type: String,
        default: ''
      },
      cardType: {
        type: String
      },
      componentList: {
        type: Array,
        default: () => ([])
      },
      certificateStatus: {
        type: String,
        default: ''
      }
    },
    computed: {
      componentName() {
        return (key) => {
          return getComponentNameByComponentTypeEnums(key)
        }
      },
      certificateStatusText() {
        if (this.cardName !== '湾区认证信息' || !isCertificateAbnormal(this.certificateStatus)) {
          return ''
        }
        const item = CertificateAbnormalStatusList.find(i => i.value === this.certificateStatus)
        if (!item) {
          return ''
        }
        return `证书状态：${item.label}`
      },
      displayComponentList() {
        // 证书异常时，隐藏“认证证书”附件项（不再提供查看入口），由底部状态文字代替
        if (this.cardName !== '湾区认证信息' || !isCertificateAbnormal(this.certificateStatus)) {
          return this.componentList
        }
        return this.componentList.filter(item => !item.fieldName || item.fieldName.indexOf('认证证书') === -1)
      }
    },
    data() {
      return {}
    },
    methods: {
      initData() {
      },
      loadData() {
      }
    }
  }
</script>

<style lang="less">
.clear-float {
  overflow: hidden;
}

.p-margin {
  p {
    margin: 0;
  }
}

.lf{
  float: left;
}

.certificate-status {
  padding: 0.4rem 0;
  margin-bottom: 0.4rem;
  font-size: 1.1rem;
  color: #ff0000;
  text-align: left;
}
</style>
